import React from 'react';
import { Flex } from '@chakra-ui/react';
import { IFormFieldState } from '../../../FormFieldSet';
import SimpleFieldHeader from '../common/SimpleFieldHeader';
import { SelectEmptyState } from './SelectEmptyState';
import { SelectDisplay } from './SelectDisplay';
import { FormFieldSelect } from '@publishing-engine/domain/types/article';

interface SimpleSelectProps {
  formFieldState: IFormFieldState;
  config: FormFieldSelect;
}

export const SimpleSelect: React.FC<SimpleSelectProps> = ({
  formFieldState
}) => {
  return (
    <Flex flexDirection="column" gap={2}>
      <SimpleFieldHeader {...formFieldState} />
      {formFieldState.value ? (
        <SelectDisplay
          value={formFieldState.value as string}
        />
      ) : (
        <SelectEmptyState />
      )}
    </Flex>
  );
};

export default SimpleSelect;
